/* Timbrica — /nickname-generator. Ники, символы и ГЛАВНОЕ: где они пройдут.
 *
 * ПОЧЕМУ ЭТОТ ТУЛ
 * ---------------
 * Кластер спроса: «символы для ника» 46 036, «генератор имен» 46 572,
 * «генератор ников» 37 913 — 130 521 показов/мес. В выдаче копипаст-страницы
 * (nickgen, symbl.cc, convertilo, smile-emoji, symbolsfornicknames, kakras):
 * дают ник с ࿇ и ༒ и на этом заканчивают.
 *
 * ЧЕГО НЕТ НИ У КОГО
 * Человек несёт красивый ник в Telegram или Minecraft и получает отказ: там
 * только латиница, или лимит длины, или запрет комбинируемых знаков. Мы
 * показываем это СРАЗУ, до того как он потратит попытку. Правила и проверка
 * живут в nickname-core.js и покрыты тестами.
 */
(function () {
  'use strict';

  var C = window.NICK_CFG || {};
  var T = C.t || {};
  var tr = function (k) { return T[k] != null ? T[k] : k; };
  var $ = function (id) { return document.getElementById(id); };
  var ae = function (ev, p) { try { window.__ae && window.__ae(ev, p || {}); } catch (e) {} };
  var stage = function (n) { try { window.__stage && window.__stage(n); } catch (e) {} };

  var N = window.NicknameCore;
  if (!N) return;

  var state = { seed: 1, current: '', style: '', decorIndex: -1 };

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }
  function setText(id, v) { var el = $(id); if (el) el.textContent = v; }

  function copy(text, btn) {
    var done = function () {
      if (!btn) return;
      var old = btn.getAttribute('data-label') || btn.textContent;
      btn.setAttribute('data-label', old);
      btn.textContent = tr('copied');
      setTimeout(function () { btn.textContent = old; }, 1200);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(done).catch(fallback);
    } else fallback();
    function fallback() {
      var ta = document.createElement('textarea');
      ta.value = text; ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); done(); } catch (e) {}
      document.body.removeChild(ta);
    }
    ae('feature_use', { slug: 'nickname-generator', feature: 'copy' });
  }

  // ── Список ников ────────────────────────────────────────────────────────────

  function words() {
    return {
      adjectives: (tr('w_adjectives') || '').split('|').filter(Boolean),
      nouns: (tr('w_nouns') || '').split('|').filter(Boolean)
    };
  }

  var CYRILLIC = /[Ѐ-ӿ]/;

  /**
   * Кириллическая основа — это ТУПИК, и молчать об этом нельзя.
   *
   * Замерено 13.08.2026: ввод «Фарид» даёт варианты, которые принимает ровно
   * ОДНА площадка из восьми — Steam. Discord, Telegram, Instagram, X, Minecraft,
   * Roblox и GitHub требуют латиницу. То есть русский пользователь — то есть
   * основная аудитория этого тула — вводил своё имя и получал восемь красных
   * крестов подряд, без единой подсказки, что делать дальше.
   *
   * Поэтому переводим основу в латиницу общим примитивом (window.Transliterator,
   * стандарт МВД — он ASCII-only) и говорим человеку, что именно сделали.
   * Свой транслит здесь писать нельзя: он уже есть и оттестирован.
   */
  /**
   * Латиница из любой строки с кириллицей, или null.
   *
   * Применяется НЕ ТОЛЬКО к основе. Списки слов у тула локализованы, поэтому на
   * русской локали генератор честно подмешивает русские существительные — и
   * выдаёт «Farid.туман», который отвергают семь площадок из восьми. Замерено
   * 13.08.2026. Переводим ВЕСЬ вариант: русский колорит сохраняется («туман» →
   * «tuman»), а ник становится годным для площадок.
   */
  function latinBase(base) {
    if (!base || !CYRILLIC.test(base)) return null;
    var TL = window.Transliterator;
    if (!TL || !TL.transliterate) return null;
    try {
      /* Два места, где легко ошибиться, и я ошибся в обоих подряд:
         1) стандарт ОБЯЗАТЕЛЕН — без него бросается «unknown standard
            "undefined"», а не берётся значение по умолчанию;
         2) возвращается ОБЪЕКТ {output, tokens, notes}, а не строка —
            String() от него даёт «[object Object]», и на экран уезжало
            «objectObject».
         Берём МВД-864: он asciiOnly, а нам нужна латиница без диакритики. */
      var res = TL.transliterate(base, 'mvd-864');
      var out = String((res && res.output) || '').replace(/[^A-Za-z0-9_.-]/g, '');
      return out && out.toLowerCase() !== base.toLowerCase() ? out : null;
    } catch (e) { return null; }
  }

  function renderList() {
    var box = $('nkList');
    if (!box) return;
    var typed = ($('nkBase') && $('nkBase').value || '').trim();
    var latin = latinBase(typed);
    var base = latin || typed;

    // Строка-объяснение: что и почему подменили. Без неё замена выглядит как
    // «тул не понял, что я ввёл».
    var note = $('nkTranslitNote');
    if (note) {
      if (latin) {
        note.textContent = tr('translit_note').replace(':from', typed).replace(':to', latin);
        note.hidden = false;
        if (!state.translitReported) {
          state.translitReported = true;
          ae('feature_use', { slug: 'nickname-generator', feature: 'translit', from_len: typed.length });
        }
      } else {
        note.hidden = true;
      }
    }

    var list = N.generate(words(), {
      count: 12, seed: state.seed, base: base,
      digits: $('nkDigits') ? $('nkDigits').checked : true,
      maxLen: 16
    });

    // Кириллица могла приехать из локализованных списков слов, даже если основа
    // была латинской. Ник, который не принимает никто, кроме Steam, — не ник.
    list = list.map(function (n) { return latinBase(n) || n; })
      .filter(function (n, i, a) { return n && a.indexOf(n) === i; });
    box.innerHTML = '';
    if (!list.length) { box.innerHTML = '<p class="nk-none">' + esc(tr('no_words')) + '</p>'; return; }
    list.forEach(function (nick) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'nk-item' + (nick === state.current ? ' on' : '');
      b.textContent = nick;
      b.addEventListener('click', function () { select(nick); });
      box.appendChild(b);
    });
    if (!state.current) select(bestFit(list), true);
  }

  /**
   * Какой вариант подставить сразу. Раньше брался ПЕРВЫЙ — и это было прямым
   * противоречием обещанию тула: он говорит «скажу, где примут», а сам открывал
   * человека вариантом с точкой, который отвергают Telegram, X, Minecraft,
   * Roblox и GitHub. Первым должен стоять тот, что подходит наибольшему числу
   * площадок; при равенстве — тот, что раньше в списке (порядок не прыгает).
   */
  function bestFit(list) {
    if (!list.length) return '';
    var best = list[0], bestScore = -1;
    for (var i = 0; i < list.length; i++) {
      var score = 0;
      try {
        score = N.checkAll(list[i]).filter(function (c) { return c.ok; }).length;
      } catch (e) { score = 0; }
      if (score > bestScore) { bestScore = score; best = list[i]; }
    }
    return best;
  }

  function select(nick, quiet) {
    state.current = nick;
    state.style = ''; state.decorIndex = -1;
    var inp = $('nkResult');
    if (inp) inp.value = nick;
    renderChecks();
    renderStyles();
    renderList();
    if (!quiet) ae('feature_use', { slug: 'nickname-generator', feature: 'pick' });
    markAnswered(nick);
  }

  /* Ответ выдан — ник выбран и проверен по площадкам. Кладём, СКОЛЬКИМ
     площадкам он подошёл: тул обещает «скажу, где примут», и доля отказов —
     это и есть качество обещания. Если у большинства ник не проходит нигде,
     чинить надо генератор, а не текст на странице. */
  var answered = false;
  function markAnswered(nick) {
    if (answered || !nick) return;
    answered = true;
    var fits = 0, total = 0;
    try {
      var res = N.checkAll(nick);
      total = res.length;
      fits = res.filter(function (r) { return r.ok; }).length;
    } catch (e) { /* проверка не должна ронять телеметрию */ }
    // ⚠️ ОТЛОЖЕННО, и это не мелочь: первая отрисовка случается ВНУТРИ boot(),
    // до stage('ready'), поэтому прямой вызов давал порядок
    // load -> complete -> ready. Воронка, где ответ выдан раньше готовности,
    // не просто выглядит странно — в ней бессмысленны все задержки dwell_ms.
    setTimeout(function () { stage('complete'); }, 0);
    ae('tool_complete', {
      slug: 'nickname-generator',
      len: nick.length,
      fits: fits,
      platforms: total,
      cyrillic: /[Ѐ-ӿ]/.test(nick) ? 1 : 0,
    });
  }

  function currentText() {
    var inp = $('nkResult');
    return inp ? inp.value : state.current;
  }

  // ── Стили и украшения ───────────────────────────────────────────────────────

  function renderStyles() {
    var box = $('nkStyles');
    if (!box) return;
    var src = state.current || currentText();
    box.innerHTML = '';
    N.STYLES.forEach(function (style) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'nk-style';
      b.textContent = N.stylize(src || 'Nick', style);
      b.addEventListener('click', function () {
        var inp = $('nkResult');
        if (inp) { inp.value = N.stylize(state.current || src, style); renderChecks(); }
        ae('feature_use', { slug: 'nickname-generator', feature: 'style_' + style });
      });
      box.appendChild(b);
    });

    var dec = $('nkDecors');
    if (!dec) return;
    dec.innerHTML = '';
    N.DECOR.forEach(function (pair, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'nk-style';
      b.textContent = pair[0] + (src || 'Nick') + pair[1];
      b.addEventListener('click', function () {
        var inp = $('nkResult');
        if (inp) { inp.value = N.decorate(inp.value, i); renderChecks(); }
        ae('feature_use', { slug: 'nickname-generator', feature: 'decor' });
      });
      dec.appendChild(b);
    });
  }

  // ── Проверка площадок ───────────────────────────────────────────────────────

  function reasonText(reasons, max) {
    return reasons.map(function (r) {
      return r === 'too_long' ? tr('r_too_long').replace(':max', String(max)) : tr('r_' + r);
    }).join(' · ');
  }

  function renderChecks() {
    var box = $('nkChecks');
    if (!box) return;
    var nick = currentText();
    setText('nkLen', String(N.codePointLength(nick)));
    var res = N.checkAll(nick);
    box.innerHTML = '';
    res.forEach(function (r) {
      var row = document.createElement('div');
      row.className = 'nk-check ' + (r.ok ? 'ok' : 'no');
      row.innerHTML = '<span class="nk-check-i">' + (r.ok ? '✓' : '✕') + '</span>' +
        '<span class="nk-check-n">' + esc(tr('p_' + r.key)) + '</span>' +
        '<span class="nk-check-r">' + esc(r.ok ? tr('fits') : reasonText(r.reasons, r.max)) + '</span>';
      box.appendChild(row);
    });
    var okCount = res.filter(function (r) { return r.ok; }).length;
    setText('nkFitCount', okCount + ' / ' + res.length);
  }

  // ── Палитра символов ────────────────────────────────────────────────────────

  function renderSymbols() {
    var box = $('nkSymbols');
    if (!box) return;
    var groups = (tr('symbol_groups') || '').split('|');
    var sets = [
      '★☆✦✧✩✪✫✬✭✮✯✰⋆∗',
      '♡♥❤❥❦❧♢♦♧♣♤♠',
      '꧁꧂༺༻【】〖〗《》⟬⟭〔〕',
      '༒࿇☬☫☪☭⚔⚡✰⚜⛧',
      '彡ミ乇卂几ㄒ丂ㄖ尺卄',
      '๛ᴥ•́ω•̀ヅツ웃유ღ'
    ];
    box.innerHTML = '';
    sets.forEach(function (set, i) {
      var wrap = document.createElement('div');
      wrap.className = 'nk-symgroup';
      var h = document.createElement('div');
      h.className = 'nk-symtitle';
      h.textContent = groups[i] || '';
      wrap.appendChild(h);
      var row = document.createElement('div');
      row.className = 'nk-symrow';
      Array.from(set).forEach(function (ch) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'nk-sym';
        b.textContent = ch;
        b.title = tr('click_to_copy');
        b.addEventListener('click', function () {
          var inp = $('nkResult');
          // Символ добавляем в ник, а не просто копируем: это на один шаг
          // короче, а копирование остаётся отдельной кнопкой.
          if (inp) { inp.value = inp.value + ch; renderChecks(); }
          copy(ch, null);
        });
        row.appendChild(b);
      });
      wrap.appendChild(row);
      box.appendChild(wrap);
    });
  }

  function boot() {
    stage('load');
    var on = function (id, fn, ev) { var el = $(id); if (el) el.addEventListener(ev || 'click', fn); };
    on('nkMore', function () { state.seed = (state.seed * 7919 + 13) >>> 0; state.current = ''; renderList(); });
    on('nkBase', function () { state.seed = 1; state.current = ''; renderList(); }, 'input');
    on('nkDigits', function () { state.current = ''; renderList(); }, 'change');
    on('nkResult', renderChecks, 'input');
    on('nkCopy', function (e) { copy(currentText(), e.currentTarget); });
    on('nkReset', function () { if (state.current) select(state.current); });

    renderList();
    renderSymbols();
    renderChecks();
    stage('ready');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
}());
